import React, {useState} from "react";
import {createPortal} from "react-dom";
import {Link, MemoryRouter, Route, Routes, UNSAFE_LocationContext, UNSAFE_RouteContext, useLocation, useNavigate} from "react-router-dom";
import {Modal} from "react-bootstrap";
import CatalogByPath from "../catalog/CatalogByPath";
import ProductPage from "../product/Product";
import {CatalogInModal} from "../catalog/CatalogInModal";

/**
 * Каталог категории в модальном окне поверх чата консультанта — по ссылке на раздел в ответе: та же страница
 * каталога с фильтрами. Внутри окна свой роутер в памяти: фильтры и сортировка не меняют адрес страницы под окном,
 * подкатегории и товары открываются в окне; остальные ссылки — переход на странице, окно закрывается.
 */
export default function ChatCategoryModal({href, show, onHide}: {href: string, show: boolean, onHide: () => void}) {
    const navigate = useNavigate();
    // Шапка окна: заголовок раздела (или «Назад в категорию» на странице товара) рисуется в неё из роутера окна
    const [title, setTitle] = useState<HTMLElement | null>(null);
    const leave = (path: string) => {
        onHide();
        navigate(path);
    };

    return <Modal show={show} onHide={onHide} size="xl" scrollable dialogClassName="chat-category-modal">
        <Modal.Header closeButton>
            <div ref={setTitle} className="chat-category-modal__title"/>
            <Link to={href} className="chat-link small text-nowrap ms-auto me-3" onClick={onHide}>Открыть страницу категории</Link>
        </Modal.Header>
        <Modal.Body>
            {show && <UNSAFE_LocationContext.Provider value={null as any}>
                <UNSAFE_RouteContext.Provider value={{outlet: null, matches: [], isDataRoute: false}}>
                    <CatalogInModal.Provider value={true}><MemoryRouter initialEntries={[href]}>
                        <BackToCategory target={title}/>
                        <Routes>
                            <Route path="/catalog/list/:categoryId/*" element={<CatalogByPath inModal headerTarget={title}/>}/>
                            <Route path="/catalog/item/:categoryId/:productId/:slug" element={<ProductPage inModal/>}/>
                            <Route path="*" element={<Leave onLeave={leave}/>}/>
                        </Routes>
                    </MemoryRouter></CatalogInModal.Provider>
                </UNSAFE_RouteContext.Provider>
            </UNSAFE_LocationContext.Provider>}
        </Modal.Body>
    </Modal>;
}

// Из каталога в окне открыли товар — назад к разделу
function BackToCategory({target}: {target: HTMLElement | null}) {
    const location = useLocation();
    const navigate = useNavigate();

    return target && location.pathname.startsWith('/catalog/item/')
        ? createPortal(<button type="button" className="btn btn-sm gray" onClick={() => navigate(-1)}>← Назад в категорию</button>, target)
        : null;
}

function Leave({onLeave}: {onLeave: (path: string) => void}) {
    const location = useLocation();
    React.useEffect(() => onLeave(location.pathname + location.search), []);

    return null;
}
